<template>
	<div class="sidebar tw-h-screen tw-flex tw-flex-col tw-bg-white tw-fixed tw-top-0 tw-right-0" v-if="course_fully_loaded" :class="{'full-screen': full_screen}"
		 v-click-outside="closeSidebarOnMobile">
		<div class="sidebar-top tw-flex tw-p-4">
			<div class="course-img tw-rounded-full tw-overflow-hidden">
				<img class="tw-w-full tw-h-full tw-object-cover" :src="course.image ? course.image.url : '/img/image.resized.jpg?width=600'" onerror="this.src='/img/image.resized.jpg?width=600'">
			</div>
			<div class="tw-flex tw-flex-1 tw-flex-col tw-ml-3">
				<div class="tw-flex">
					<h2 class="course-title tw-flex-1 tw-text-gray-800 tw-my-1 tw-font-bold tw-text-lg tw-leading-normal"
						v-text="course.name"></h2>
					<router-link :to="{name: 'courses.show', params: { course_slug: course.slug }}"
								 class="module-link-btn tw-flex tw-items-center tw-justify-center tw-rounded-full tw-ml-2 tw-bg-gray-100 tw-text-gray-600 tw-mt-1"
								 style="width: 30px; height: 30px;"
					>
						<i class="far fa-list"></i>
					</router-link>
					<div class="close-sidebar-btn secondary-c-bg secondary-c-contrast tw-items-center tw-justify-center tw-rounded-full tw-ml-2 tw-mt-2 tw-simple-hover"
						 style="width: 30px; height: 30px;" @click="toggleFullScreen">
						<i class="fa fa-arrow-right"></i>
					</div>
				</div>
				<div class="course-meta tw-flex tw-items-center">
					<template v-if="modules_count > 1">
						<span>{{ modules_count }} {{ $t('membership.modules') }}</span>
						<div class="dot"></div>
					</template>
					<span>{{ lessons_count }} {{ $t('membership.lessons') }}</span>
				</div>
				<div class="course-progress-bar tw-relative tw-bg-gray-200 tw-rounded-lg tw-overflow-hidden tw-mt-4"
					 v-if="$settings('membership.show_progress') == '1'" style="height: 5px;">
					<div class="course-progress-bar-inner tw-h-full tw-bg-gray-400 tw-absolute tw-left-0 tw-top-0"
						 :style="{width: courseProgress + '%'}"></div>
				</div>
			</div>
		</div>
		<div ref="sidebarWrapper" v-bar>
			<div ref="sidebar">
				<div class="sidebar-inner tw-flex tw-flex-col tw-flex-1 tw-m-4 tw-mt-2">
					<sidebarmodule v-for="(module, index) in modules" :key="module.id" :module="module"
								   :modules="modules" :course="course" :index="index"
								   :modules_count="modules_count" :chapters_structure="chapters_structure"></sidebarmodule>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import SidebarModule from "../../components/e-learning/SidebarModule";
	import vClickOutside from 'v-click-outside';

	export default {
		name: 'LessonSidebar',

		components: {
			sidebarmodule: SidebarModule,
		},

		props: {
			course_fully_loaded: {
				required: true,
			},
			course: {
				required: true,
			},
			full_screen: {
				required: true,
			},
		},

		data() {
			return {
				envoyer_release_id,
			};
		},

		computed: {
			modules() {
				return this.course_fully_loaded ? this.course.modules.filter((module) => !module.no_dashboard || module.lessons.length > 0) : [];
			},

			modules_count() {
				return this.modules.filter(module => {
					return module.no_dashboard === false || module.lessons.length > 1;
				}).length;
			},

			lessons_count() {
				let lessons_count = 0;

				for (let i = 0; i < this.modules.length; i += 1) {
					lessons_count += this.modules[i].lessons.length;
				}

				return lessons_count;
			},

			chapters_structure() {
				// generate chapter structure for top level modules or lessons
				// lessons in a module are automatically calculated based on index of modules.lessons in SidebarModule.vue

				const arr = [];
				let chapter_number;
				let lesson_number;

				this.modules.forEach((module, i) => {
					const prev = arr[arr.length - 1];
					const prev_module = this.modules[i - 1];

					// if this is not a module and the previous module is also not a module we group them together
					if (module.no_dashboard && module.lessons.length <= 1 && prev_module && prev_module.no_dashboard && prev_module.lessons.length <= 1) {
						chapter_number = prev.chapter;
						lesson_number = prev.lesson + 1;
					} else if(!module.no_dashboard || module.lessons.length > 1) {
						// check if its a module (its also a module if the no_dashboard module has more than 1 lesson due to old legacy working of this feature)
						if(prev) {
							// if module, get previous chapter + 1
							chapter_number = prev.chapter + 1;
							lesson_number = 0;
						} else {
							chapter_number =  1;
							lesson_number = 0;
						}
					} else {
						// if lesson, check if previous lesson number > 0
						if(!prev) {
							chapter_number = 1;
							lesson_number = 0;
						} else if(prev.lesson > 0) {
							// if above 1, add one to lesson and keep chapter nr same
							chapter_number = prev.chapter;
							lesson_number = prev.lesson + 1;
						} else {
							// else, lesson = 1 and add one to chapter number
							chapter_number = prev.chapter + 1;
							lesson_number = 1;
						}
					}
					arr.push({chapter:chapter_number, lesson:lesson_number});
				});

				return arr;
			},

			courseProgress() {
				let progress = 100;

				if (this.lessons_count > 0) {
					const percentagePerLesson = 100 / this.lessons_count;

					for (let i = 0; i < this.modules.length; i += 1) {
						for (let y = 0; y < this.modules[i].lessons.length; y += 1) {
							if (!this.modules[i].lessons[y].seen) {
								progress -= percentagePerLesson;
							}
						}
					}
				}

				return progress;
			},
		},

		methods: {
			closeSidebarOnMobile() {
				if (window.innerWidth < 1100 && this.full_screen) {
					this.full_screen = false;
				}
			},

			toggleFullScreen() {
				this.$emit('toggleFullScreen');
			},
		},

		directives: {
			clickOutside: vClickOutside.directive,
		},
	};
</script>

<style lang="scss" scoped>
	.sidebar {
		transition: right 0.2s ease;
		top: 70px;
		width: 350px;
		box-shadow: -8px 0 10px -8px rgba(0, 0, 0, 0.1);

		@media(max-width: 1100px) {
			top: 64px;
			z-index: 9997;
			right: -365px;
		}

		&.full-screen {
			right: -365px;

			@media(max-width: 1100px) {
				right: 0;
			}
		}

		.sidebar-top {
			box-shadow: 0px 2px 5px -5px #717171;

			.course-img {
				width: 55px;
				height: 55px;
			}

			.module-link-btn {
				@media(max-width: 1100px) {
					display: none;
				}
			}

			.close-sidebar-btn {
				display: none;

				@media(max-width: 1100px) {
					display: flex;
				}
			}

			.course-title {
				@apply tw-leading-normal tw-mb-0 #{!important};
			}

			.course-meta {
				span {
					@apply tw-font-bold tw-text-xs tw-uppercase;
					color: #cac8c8;
				}

				.dot {
					@apply tw-ml-2 tw-mr-2 tw-bg-gray-200;
					width: 4px;
					height: 4px;
					border-radius: 100%;
					margin-top: -1px;
				}
			}

			.course-progress-bar {
				.course-progress-bar-inner {
					transition: width 0.2s ease;
				}
			}

			@media(max-width: 1100px) {
				@apply tw-px-7 tw-py-8;

				.course-img {
					display: none;
				}

				.course-title {
					margin-left: 0;
				}

				.course-meta {
					margin-left: 0;
				}
			}
		}

		.vb {
			flex: 1;
		}

		.sidebar-inner {
			padding-bottom: 50px;
		}
	}
</style>